import { transport } from "@/src/config/apiConfig.js";

export default {
  async getCallToken(params) {
    try {
      let res = await transport.get(`/api/calls_service/call/token`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting call token: ", error);
      throw error;
    }
  },

  async getDialerSettings() {
    try {
      const res = await transport.get(`/api/settings/dialer_settings`);
      return res.data;
    } catch (error) {
      console.error("Error fetching dialer settings:", error);
      throw error;
    }
  },

  async getDialerSetting(setting_key) {
    try {
      const res = await transport.get(`/api/settings/dialer_setting`, {
        params: { setting_key },
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching dialer setting:", error);
      throw error;
    }
  },

  async updateDialerSetting(setting_key, setting_value) {
    try {
      const res = await transport.post(`/api/settings/dialer_setting`, {
        setting_key,
        setting_value,
      });
      return res.data;
    } catch (error) {
      console.error("Error updating dialer setting:", error);
      throw error;
    }
  },

  async getPhoneNumbers(params) {
    try {
      let res = await transport.get(`/api/calls_service/phone_numbers`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting phone numbers: ", error);
      throw error;
    }
  },

  async previewPhoneNumber(params) {
    try {
      let res = await transport.get(
        `/api/calls_service/phone_numbers/preview`,
        {
          params: params,
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while previewing phone number: ", error);
      throw error;
    }
  },

  async purchasePhoneNumber(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/phone_numbers/purchase`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while purchasing phone number: ", error);
      throw error;
    }
  },

  async deletePhoneNumber(params = {}) {
    try {
      let res = await transport.delete(
        `/api/calls_service/phone_numbers/${params?.id}?provider=${params?.provider}`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting phone number: ", error);
      throw error;
    }
  },

  async fetchPhoneNumberDetails(params) {
    try {
      let res = await transport.get(
        `/api/calls_service/phone_numbers/details`,
        {
          params: params,
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching phone number details: ",
        error,
      );
      throw error;
    }
  },

  async getAreaCodes(code) {
    try {
      let res = await transport.get(
        `/api/calls_service/phone_numbers/area_codes/${code}`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting area codes: ", error);
      throw error;
    }
  },

  async getLocalPresenceNumber(params) {
    try {
      let res = await transport.get(
        `/api/calls_service/phone_numbers/local_presence`,
        {
          params: params,
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting local presence number: ",
        error,
      );
      throw error;
    }
  },

  async getActivityWithSSID(id) {
    try {
      let res = await transport.get(`/api/calls_service/call/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting activity with SSID: ",
        error,
      );
      throw error;
    }
  },

  async addCallNote(id, payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/${id}/note`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while adding call note: ", error);
      throw error;
    }
  },

  async logManualCall(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/log_manual`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while logging manual call: ", error);
      throw error;
    }
  },

  async updateManualCall(callSid, payload) {
    try {
      let res = await transport.patch(
        `/api/calls_service/call/manual/${callSid}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating manual call: ", error);
      throw error;
    }
  },

  async getAllCallCampaigns(params) {
    try {
      let res = await transport.get(`/api/calls_campaigns`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting all call campaigns: ",
        error,
      );
      throw error;
    }
  },

  async getCallCampaignById(id) {
    try {
      let res = await transport.get(`/api/calls_campaigns/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting call campaign by ID: ",
        error,
      );
      throw error;
    }
  },

  async createCallCampaign(payload) {
    try {
      let res = await transport.post(`/api/calls_campaigns`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating call campaign: ", error);
      throw error;
    }
  },

  async updateCallCampaign(id, payload) {
    try {
      let res = await transport.patch(`/api/calls_campaigns/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating call campaign: ", error);
      throw error;
    }
  },

  async fetchCallCampaigns({
    page = 1,
    pageSize = 10,
    searchQuery = "",
    campaignType = null,
    filters = [],
  }) {
    try {
      const params = {
        page,
        page_size: pageSize,
        search: searchQuery,
        filters: JSON.stringify(filters),
      };

      if (campaignType) {
        params.campaign_type = campaignType;
      }

      let res = await transport.get(`/api/calls_campaigns`, { params });
      return res.data;
    } catch (error) {
      console.error("Error fetching call campaigns:", error);
      throw error;
    }
  },

  async getCallCampaignStats(id) {
    try {
      let res = await transport.get(`/api/calls_campaigns/${id}/stats`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting call campaign stats: ",
        error,
      );
      throw error;
    }
  },

  async nextCallCampaignStep(id) {
    try {
      let res = await transport.get(`/api/calls_campaigns/${id}/next_call`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting next call campaign step: ",
        error,
      );
      throw error;
    }
  },

  async getCallCampaignLeadsList(id, params) {
    try {
      let res = await transport.get(`/api/calls_campaigns/${id}/lead_list`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting call campaign leads list: ",
        error,
      );
      throw error;
    }
  },

  async deleteCallCampaign(id) {
    try {
      let res = await transport.delete(`/api/calls_campaigns/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting call campaign: ", error);
      throw error;
    }
  },

  async updateCallCampaignLeadStatus(payload) {
    try {
      let res = await transport.patch(`/api/calls_campaigns/leads`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating call campaign lead status: ",
        error,
      );
      throw error;
    }
  },

  async addEntitiesToCampaign(payload) {
    try {
      let res = await transport.post(
        `/api/calls_campaigns/add_entities`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while adding entities to campaign: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ VOICEMAILS ------------------------------

  async fetchVoicemails(params = {}) {
    try {
      const { search, page, page_size } = params;
      const queryParams = {};
      
      if (search) queryParams.search = search;
      if (page) queryParams.page = page;
      if (page_size) queryParams.page_size = page_size;
      
      let res = await transport.get(`/api/voicemails`, { params: queryParams });
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching voicemails: ", error);
      throw error;
    }
  },

  async fetchVoicemailById(id) {
    try {
      let res = await transport.get(`/api/voicemails/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching voicemail by ID: ",
        error,
      );
      throw error;
    }
  },

  async createVoicemail(payload) {
    try {
      let res = await transport.post(`/api/voicemails`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating voicemail: ", error);
      throw error;
    }
  },

  async updateVoicemail(id, payload) {
    try {
      let res = await transport.patch(`/api/voicemails/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating voicemail: ", error);
      throw error;
    }
  },

  async deleteVoicemail(id) {
    try {
      let res = await transport.delete(`/api/voicemails/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting voicemail: ", error);
      throw error;
    }
  },

  async dropVoicemail(callSid, voicemailId) {
    try {
      let res = await transport.post(`/api/calls_service/drop_voicemail/${callSid}`, {
        voicemail_id: voicemailId,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while dropping voicemail: ", error);
      throw error;
    }
  },

  // ------------------------------ RECORDING ------------------------------

  async initiateCallRecording(ssid, payload) {
    try {
      let res = await transport.post(`/api/recordings/${ssid}`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while initiating call recording: ",
        error,
      );
      throw error;
    }
  },

  async getRecordTranscript(id) {
    try {
      let res = await transport.get(`/api/recording/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting record transcript: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ RECORDING CONSENT ------------------------------

  async checkRecordingConsent() {
    try {
      let res = await transport.get(`/api/consent/check`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while checking recording consent: ",
        error,
      );
      throw error;
    }
  },

  async updateRecordingConsent(payload) {
    try {
      let res = await transport.post(`/api/consent`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating recording consent: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ FORWARDING ------------------------------

  async addForwardingNumber(id, payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/phone_numbers/forwarding_number/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while adding forwarding number: ",
        error,
      );
      throw error;
    }
  },

  async updateForwardingNumber(id, payload) {
    try {
      let res = await transport.patch(
        `/api/calls_service/phone_numbers/forwarding_number/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating forwarding number: ",
        error,
      );
      throw error;
    }
  },

  async reassignPhoneNumber(payload) {
    try {
      let res = await transport.patch(
        `/api/calls_service/phone_numbers/reassign`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while reassigning phone number: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ CALL LOGS ------------------------------

  async fetchCallLogs(params) {
    try {
      let res = await transport.get(`/api/calls_service/call/list`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching call logs: ", error);
      throw error;
    }
  },

  async fetchCallLogViews() {
    try {
      let res = await transport.get(`/api/call_log/views`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing fetchCallLogViews: ",
        error,
      );
      throw error;
    }
  },

  async exportDialerCallLogs(params) {
    try {
      let res = await transport.post(`/api/views/call_log/export`, params);
      return res.data;
    } catch (error) {
      console.error("Error initiating dialer call log export:", error);
      throw error;
    }
  },

  // ------------------------------ CALL ROUTING ------------------------------

  async getAllCallRoutes() {
    try {
      let res = await transport.get(`/api/calls_service/routes`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting all call routes: ", error);
      throw error;
    }
  },

  async getCallRouteById(id) {
    try {
      let res = await transport.get(`/api/calls_service/routes/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting call route by ID: ",
        error,
      );
      throw error;
    }
  },

  async createCallRoute(payload) {
    try {
      let res = await transport.post(`/api/calls_service/routes`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating call route: ", error);
      throw error;
    }
  },

  async updateCallRoute(id, payload) {
    try {
      let res = await transport.put(`/api/calls_service/routes/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating call route: ", error);
      throw error;
    }
  },

  async deleteCallRoute(id) {
    try {
      let res = await transport.delete(`/api/calls_service/routes/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting call route: ", error);
      throw error;
    }
  },

  // ------------------------------ CALL TRANSFER ------------------------------

  async transferCall(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/transfer_call`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while transferring call: ", error);
      throw error;
    }
  },

  // ------------------------------ WARM TRANSFER ------------------------------

  async fetchConferenceDetails(id) {
    try {
      let res = await transport.get(
        `/api/calls_service/call/conference/details/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching conference details: ",
        error,
      );
      throw error;
    }
  },

  async warmTransfer(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/warm_transfer`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while warm transferring: ", error);
      throw error;
    }
  },

  async handleHoldCall(payload) {
    try {
      let res = await transport.post(`/api/calls_service/call/hold`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while handling hold call: ", error);
      throw error;
    }
  },

  async swapCallsInConference(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/transfer/swap`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while swapping calls in conference: ",
        error,
      );
      throw error;
    }
  },

  async completeTransfer(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/transfer/complete`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while completing transfer: ", error);
      throw error;
    }
  },

  async cancelTransfer(payload, { signal } = {}) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/transfer/cancel`,
        payload,
        { signal },
      );
      return res.data;
    } catch (error) {
      if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
        return { aborted: true };
      }
      console.error("An error occurred while cancelling transfer: ", error);
      throw error;
    }
  },

  async mergeConference(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/conference/merge`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while merging conference: ", error);
      throw error;
    }
  },

  async conferenceKickParticipant(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/conference/kick`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while kicking conference participant: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ CALL AVAILABILITY ------------------------------

  async fetchCallAvailability() {
    try {
      let res = await transport.get(`/api/user_availability/call`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching call availability: ",
        error,
      );
      throw error;
    }
  },

  async updateCallAvailability(payload) {
    try {
      let res = await transport.post(`/api/user_availability/call`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating call availability: ",
        error,
      );
      throw error;
    }
  },

  //------------------------------ Fetch fetchCampaignEntityStatus Call ------------------------------

  async fetchCampaignEntityStatus(id) {
    try {
      let res = await transport.get(
        `/api/calls_campaigns/campaign_entity_status/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching campaign entity status: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ PURCHASING INTERNATIONAL PHONE NUMBER ------------------------------

  async createEndUser(payload) {
    try {
      let res = await transport.post(
        `/api/regulatory_bundles/create/end_user`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating end user: ", error);
      throw error;
    }
  },

  async createRegulatoryBundle(payload) {
    try {
      let res = await transport.post(
        `/api/regulatory_bundles/create/bundle`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating regulatory bundle: ",
        error,
      );
      throw error;
    }
  },

  async createNzRegulatoryBundle(payload) {
    try {
      let res = await transport.post(
        `/api/regulatory_bundles/new_zealand/create/bundle`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating New Zealand regulatory bundle: ",
        error,
      );
      throw error;
    }
  },

  async createChRegulatoryBundle(payload) {
    try {
      let res = await transport.post(
        `/api/regulatory_bundles/switzerland/create/bundle`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating Switzerland regulatory bundle: ",
        error,
      );
      throw error;
    }
  },

  async previewRegulatoryBundle(params) {
    try {
      let res = await transport.get(`/api/regulatory_bundles/preview/bundle`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while previewing regulatory bundle: ",
        error,
      );
      throw error;
    }
  },

  async previewAddress(id) {
    try {
      let res = await transport.get(
        `/api/regulatory_bundles/preview/address/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while previewing address: ", error);
      throw error;
    }
  },

  async createAddress(payload) {
    try {
      let res = await transport.post(
        `/api/regulatory_bundles/create/address`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating address: ", error);
      throw error;
    }
  },

  async getBundleStatus(params) {
    try {
      let res = await transport.get(`/api/regulatory_bundles/get/status`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting bundle status: ", error);
      throw error;
    }
  },

  // ------------------------------ 2 FACTOR AUTHENTICATION ------------------------------

  async sendCode(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/phone_number/2fa/send_code`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while sending code: ", error);
      throw error;
    }
  },

  async verifyCode(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/phone_number/2fa/verify_code`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while verifying code: ", error);
      throw error;
    }
  },

  // ------------------------------ CALL DATA UPDATE ------------------------------

  async updateCallData(id, data) {
    try {
      let res = await transport.patch(
        `/api/calls_service/call/update_data/${id}`,
        data,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating call data: ", error);
      throw error;
    }
  },

  // ------------------------------ CALL LOG CLOSED ------------------------------

  async notifyCallLogClosed(callId) {
    try {
      let res = await transport.post(
        `/api/calls_service/call/${callId}/log_closed`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while notifying call log closed: ", error);
    }
  },

  // ------------------------------ CALL DISPOSITIONS ------------------------------

  async fetchCallDispositions(params = {}) {
    try {
      let res = await transport.get(`/api/calls_service/call_dispositions`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching call dispositions: ",
        error,
      );
      throw error;
    }
  },

  async createCallDisposition(payload) {
    try {
      let res = await transport.post(
        `/api/calls_service/call_dispositions`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating call disposition: ",
        error,
      );
      throw error;
    }
  },

  async updateCallDisposition(id, payload) {
    try {
      let res = await transport.put(
        `/api/calls_service/call_dispositions/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating call disposition: ",
        error,
      );
      throw error;
    }
  },

  async deleteCallDisposition(id) {
    try {
      let res = await transport.delete(
        `/api/calls_service/call_dispositions/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting call disposition: ",
        error,
      );
      throw error;
    }
  },

  async addToDNDBlocklist(data) {
    try {
      let res = await transport.post("/api/dnd/add_to_blocklist", data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while adding to DND blocklist: ", error);
      throw error;
    }
  },

  async updateDNDStatus(data) {
    try {
      let res = await transport.put("/api/dnd/update_status", data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating DND status: ", error);
      throw error;
    }
  },

  async removeFromDNDBlocklist(number) {
    try {
      let res = await transport.delete("/api/dnd/remove_from_blocklist", {
        data: { number },
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while removing from DND blocklist: ",
        error,
      );
      throw error;
    }
  },

  async getDNDList(params) {
    try {
      let res = await transport.get("/api/dnd/list", { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching DND list: ", error);
      throw error;
    }
  },

  async bulkAddToDNDBlocklist(data) {
    try {
      let res = await transport.post("/api/dnd/bulk_add_to_blocklist", data);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while bulk adding to DND blocklist: ",
        error,
      );
      throw error;
    }
  },

  async checkEntityDNDStatus(entityId, entityType) {
    try {
      let res = await transport.get("/api/dnd/check_entity_status", {
        params: {
          entity_id: entityId,
          entity_type: entityType,
        },
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while checking entity DND status: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ PHONE NUMBER DETAILS ------------------------------

  async getPhoneNumberDetails(id) {
    try {
      let res = await transport.get(`/api/phone_numbers/details/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting phone number details: ",
        error,
      );
      throw error;
    }
  },

  async updatePhoneNumberDetails(payload) {
    try {
      let res = await transport.patch(
        `/api/phone_numbers/details/${payload.id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating phone number details: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ CALLER ID ------------------------------

  async getCallerIDs(params) {
    try {
      let res = await transport.get(`/api/caller_ids`, {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting caller IDs: ", error);
      throw error;
    }
  },

  async getCallerIDbyID(id) {
    try {
      let res = await transport.get(`/api/caller_id/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting caller ID by ID: ", error);
      throw error;
    }
  },

  async createCallerID(payload) {
    try {
      let res = await transport.post("/api/caller_id/create", payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating caller ID: ", error);
      throw error;
    }
  },

  async deleteCallerID(id) {
    try {
      let res = await transport.delete(`/api/caller_id/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting caller ID: ", error);
      throw error;
    }
  },

  async verifyPlivoCallerID(payload) {
    try {
      let res = await transport.post("/api/plivo/caller_id/verify", payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while verifying OTP: ", error);
      throw error;
    }
  },

  async fetchCITemplates(page = 1, pageSize = 20) {
    try {
      const res = await transport.get(
        "/api/conversation_intelligence/templates",
        {
          params: { page, page_size: pageSize },
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching conversation intelligence templates: ",
        error,
      );
      throw error;
    }
  },

  async createCITemplate(payload) {
    try {
      const res = await transport.post(
        "/api/conversation_intelligence/templates",
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating conversation intelligence template: ",
        error,
      );
      throw error;
    }
  },

  async updateCITemplate(id, payload) {
    try {
      const res = await transport.put(
        `/api/conversation_intelligence/templates/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating conversation intelligence template: ",
        error,
      );
      throw error;
    }
  },

  async deleteCITemplate(id) {
    try {
      const res = await transport.delete(
        `/api/conversation_intelligence/templates/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting conversation intelligence template: ",
        error,
      );
      throw error;
    }
  },

  async setPrimaryCITemplate(id) {
    try {
      const res = await transport.post(
        `/api/conversation_intelligence/templates/${id}/primary`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while setting primary conversation intelligence template: ",
        error,
      );
      throw error;
    }
  },

  async createCITemplateSetting(payload) {
    try {
      const res = await transport.post(
        "/api/conversation_intelligence/templates/settings",
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating template setting: ",
        error,
      );
      throw error;
    }
  },

  async fetchCITemplateSettings(templateId, page = 1, pageSize = 20) {
    try {
      const res = await transport.get(
        `/api/conversation_intelligence/templates/settings/template/${templateId}`,
        {
          params: { page, page_size: pageSize },
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching template settings: ",
        error,
      );
      throw error;
    }
  },

  async updateCITemplateSetting(id, payload) {
    try {
      const res = await transport.put(
        `/api/conversation_intelligence/templates/settings/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating template setting: ",
        error,
      );
      throw error;
    }
  },

  async deleteCITemplateSetting(id) {
    try {
      const res = await transport.delete(
        `/api/conversation_intelligence/templates/settings/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting template setting: ",
        error,
      );
      throw error;
    }
  },

  async getOrCreateCallIntelligence(callId, templateId = null) {
    try {
      const payload = templateId ? { template_id: templateId } : {};
      const res = await transport.post(
        `/api/conversation_intelligence/calls/${callId}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting or creating call intelligence: ",
        error,
      );
      throw error;
    }
  },

  // ------------------------------ INCOMING CALL RINGTONES ------------------------------

  async getIncomingCallRingtones(params = {}) {
    try {
      const res = await transport.get(`/api/settings/incoming_call_ringtone`, {
        params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching incoming call ringtones: ",
        error,
      );
      throw error;
    }
  },

  async createIncomingCallRingtone(payload) {
    try {
      if (!payload) {
        throw new Error("Payload is required");
      }
      const res = await transport.post(
        `/api/settings/incoming_call_ringtone`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating incoming call ringtone: ",
        error,
      );
      throw error;
    }
  },

  async updateIncomingCallRingtone(id, payload) {
    try {
      if (!id) {
        throw new Error("Ringtone ID is required");
      }
      const res = await transport.patch(
        `/api/settings/incoming_call_ringtone/${id}`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating incoming call ringtone: ",
        error,
      );
      throw error;
    }
  },

  async removeIncomingCallRingtonePrimary() {
    try {
      const res = await transport.delete(
        `/api/settings/incoming_call_ringtone_primary`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while removing primary ringtone: ",
        error,
      );
      throw error;
    }
  },

  async deleteIncomingCallRingtone(id) {
    try {
      if (!id) {
        throw new Error("Ringtone ID is required");
      }
      const res = await transport.delete(
        `/api/settings/incoming_call_ringtone/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting incoming call ringtone: ",
        error,
      );
      throw error;
    }
  },
};
